import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { IconComponent } from '../icon/icon.component';
import { ListContainerComponent } from '../list-container/list-container.component';
import { ModalAction } from '../../modals/modal-actions/modal-action.interface';
import { ModalActionsComponent } from '../../modals/modal-actions/modal-actions.component';
import { SortIconComponent } from '../sort-icon/sort-icon.component';
import { Sorts } from '../../services/pagination/models/typies/sorts.type';
import { StatusPillComponent, StatusPillEnum } from '../status-pill/status-pill.component';
import { Track } from '../../models/interfaces/track.interface';

@Component({
  selector: 'l-track-table',
  standalone: true,
  imports: [
    DatePipe,
    IconComponent,
    ListContainerComponent,
    ModalActionsComponent,
    SortIconComponent,
    StatusPillComponent,
  ],
  templateUrl: './track-table.component.html',
})
export class TrackTableComponent {

  @Input({ required: true })
  public data: Track[] = [];

  @Input({ required: true })
  public isLoading = false;

  @Input({ required: true })
  public getRowActions!: (track: Track) => ModalAction[];

  @Input()
  public limit = 10;

  @Input()
  public page = 1;

  @Input()
  public total = 0;

  @Input()
  public sort?: Sorts;

  @Output()
  public pageChange = new EventEmitter<number>();

  @Output()
  public sortChange = new EventEmitter<Sorts>();

  public readonly statusEnum: typeof StatusPillEnum = StatusPillEnum;

  public getTrackStatus(track: Track): StatusPillEnum {
    return track.isActive ? StatusPillEnum.ACTIVE : StatusPillEnum.INACTIVE;
  }

}
